export default {
  API_URL: "https://api.knowinapp.com"
  //API_URL: "http://localhost:8000"
};
